module.exports = __webpack_public_path__ + "static/media/logo.b03d1330.webp";